module.exports = __webpack_public_path__ + "static/testimonials-3-15393c5a215a67b0f4bbc4d4ed55f12c.jpg";